/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Order {
  /** @format uuid */
  id: string;

  /** @format uuid */
  mbId?: string;
  mbExternalId: string;
  number: string;
  status: string;
  isDataTransferAgreed?: boolean;
  clientFirstSign?: boolean;
  clientSecondSign?: boolean;

  /** @format date-time */
  createdAt: string;

  /** @format date-time */
  updatedAt?: string;
  accountList?: ShortAccountInfo[];
  permissions?: Permission[];
}

export interface Permission {
  name?: string;
  desc?: string;
  operation?: string;
  available?: boolean;
}

export interface ShortAccount {
  number: string;
  name?: string;
  type?: string;
  status?: string;
  currency?: string;
}

export interface ShortAccountInfo {
  type: "RU_ACC" | "FOREIGN_PAIR";
  accountingData?: ShortAccount;
  transitData?: ShortAccount;
}

export interface ErrorMessage {
  name?: string;
  description?: string;
  timestamp?: string;
}

export interface OrderUpdate {
  /** @format uuid */
  id: string;
  mbExternalId: string;
  isDataTransferAgreed?: boolean;
  accountList?: ShortAccountInfo[];
}

export interface OrderCreation {
  mbExternalId: string;
  requestedAt: string;
  isDataTransferAgreed?: boolean;
  accountList?: ShortAccountInfo[];
}

export interface OrderInfos {
  orderList?: ShortOrder[];
  hasMore: boolean;

  /** @format int32 */
  totalSize: number;
}

export interface ShortOrder {
  /** @format uuid */
  id: string;
  mbExternalId: string;
  number: string;
  status: string;
  clientFirstSign?: boolean;
  clientSecondSign?: boolean;

  /** @format date-time */
  createdAt: string;

  /** @format date-time */
  updatedAt?: string;
  permissions?: Permission[];
}

export interface CcbResponse {
  ccb?: string;
  ccbVersion?: string;
  document?: object;
}

export interface ConfirmType {
  confirmType?: string;
}

export interface ClientCertificate {
  serial?: string;
  issuer?: string;
  userId?: string;
  clientId?: string;
}

export interface GetOrderListParams {
  /**
   * Начиная с какого элемента запрашиваются данные
   * @format int32
   * @example 0
   */
  position: number;

  /**
   * Глубина запроса данных (исключая)
   * @format int32
   * @example 30
   */
  size: number;
}

export interface GetOrderCcbParams {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  orderId: string;
}

export interface GetClientAccountsParams {
  /** Фильтр типа счетов */
  accountType: "TRANSIT_ACCOUNT" | "RU_ACCOUNT" | "FOREIGN_ACCOUNT";
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис accounting-my-business
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-acc-my-business.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Бухгалтерия «Моё дело» <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=376262806)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name GetOrderList
     * @summary Получить список заявок на интеграцию с Моим делом
     * @request GET:/api/my-business/v1/external/order
     * @secure
     */
    getOrderList: (query: GetOrderListParams, params: RequestParams = {}) =>
      this.request<OrderInfos, ErrorMessage>({
        path: `/api/my-business/v1/external/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name UpdateOrder
     * @summary Обновить заявку на интеграцию с Моим делом
     * @request PUT:/api/my-business/v1/external/order
     * @secure
     */
    updateOrder: (data: OrderUpdate, params: RequestParams = {}) =>
      this.request<Order, ErrorMessage>({
        path: `/api/my-business/v1/external/order`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name CreateOrder
     * @summary Создать заявку на интеграцию с Моим делом
     * @request POST:/api/my-business/v1/external/order
     * @secure
     */
    createOrder: (data: OrderCreation, params: RequestParams = {}) =>
      this.request<Order, ErrorMessage>({
        path: `/api/my-business/v1/external/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name GetOrder
     * @summary Получить данные заявки по id
     * @request GET:/api/my-business/v1/external/order/{id}
     * @secure
     */
    getOrder: (id: string, params: RequestParams = {}) =>
      this.request<Order, ErrorMessage>({
        path: `/api/my-business/v1/external/order/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name UpdateOrderStatus
     * @summary Обновить статус подписания заявки
     * @request GET:/api/my-business/v1/external/order/{id}/status
     * @secure
     */
    updateOrderStatus: (id: string, params: RequestParams = {}) =>
      this.request<Order, ErrorMessage>({
        path: `/api/my-business/v1/external/order/${id}/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с подписанием заявок на подключение к бухгалтерии Мое Дело
     * @name GetOrderCcb
     * @summary Получить ccb заявки
     * @request GET:/api/my-business/v1/external/order-ccb
     * @secure
     */
    getOrderCcb: (query: GetOrderCcbParams, params: RequestParams = {}) =>
      this.request<CcbResponse, ErrorMessage>({
        path: `/api/my-business/v1/external/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с подписанием заявок на подключение к бухгалтерии Мое Дело
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения для клиента
     * @request GET:/api/my-business/v1/external/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmType, ErrorMessage>({
        path: `/api/my-business/v1/external/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с подписанием заявок на подключение к бухгалтерии Мое Дело
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/my-business/v1/external/client-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificate, ErrorMessage>({
        path: `/api/my-business/v1/external/client-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на подключение к бухгалтерии Мое Дело
     * @name GetClientAccounts
     * @summary Получить детальную информацию по счетам клиента
     * @request GET:/api/my-business/v1/external/account
     * @secure
     */
    getClientAccounts: (
      query: GetClientAccountsParams,
      params: RequestParams = {}
    ) =>
      this.request<ShortAccount[], ErrorMessage>({
        path: `/api/my-business/v1/external/account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
